import { AppConsts } from '@shared/AppConsts';
import { Component, Injector, ViewEncapsulation, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ProductsServiceProxy, ProductDto, CommonLookupServiceProxy, DropDownLookupDto, ProductType } from '@shared/service-proxies/service-proxies';
import { NotifyService } from 'abp-ng2-module';
import { AppComponentBase } from '@shared/common/app-component-base';
import { TokenAuthServiceProxy } from '@shared/service-proxies/service-proxies';

import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Table, TableModule } from 'primeng/table';
import { Paginator, PaginatorModule } from 'primeng/paginator';
import { LazyLoadEvent, PrimeTemplate } from 'primeng/api';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { filter as _filter } from 'lodash-es';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { HttpClient } from '@angular/common/http';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { finalize } from 'rxjs';

import { ExcelColumnSelectionModalComponent } from '@app/shared/common/excel-column-selection/excel-column-selection-modal';

@Component({
    templateUrl: './products.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
    standalone: false,
})
export class ProductsComponent extends AppComponentBase {
    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;

    @ViewChild('ExcelFileUpload', { static: false }) excelFileUpload: FileUpload;

    @ViewChild('excelColumnSelectionModal', { static: true })
    excelColumnSelectionModal: ExcelColumnSelectionModalComponent;

    advancedFiltersAreShown = false;
    barCode = '';
    productCode = '';
    productName = '';
    importDialoug = false;

    uploadUrl: string;
    downloadUrl: string;

    allDepartments: DropDownLookupDto[];
    allCategorys: DropDownLookupDto[];
    allSubCategorys: DropDownLookupDto[];
    allBrands: DropDownLookupDto[];
    allVendors: DropDownLookupDto[];
    vendorId: 0;
    brandId: 0;
    categoryId: 0;
    departmentId: 0;
    productType: ProductType;

    constructor(
        injector: Injector,
        private _productsServiceProxy: ProductsServiceProxy,
        private _notifyService: NotifyService,
        private _tokenAuth: TokenAuthServiceProxy,
        private _activatedRoute: ActivatedRoute,
        private _fileDownloadService: FileDownloadService,
        private _router: Router,
        private _dateTimeService: DateTimeService,
        private _commonLookupService: CommonLookupServiceProxy,
        private _httpClient: HttpClient,
    ) {
        super(injector);

        this.uploadUrl = AppConsts.remoteServiceBaseUrl + '/Import/ImportProduct';
        this.downloadUrl = AppConsts.remoteServiceBaseUrl + '/Import/ImportProductTemplate';
    }

    ngOnInit(): void {
        this.fillDropdown();
        this.brandId = 0;
        this.vendorId = 0;
        this.categoryId = 0;
        this.vendorId = 0;
        this.departmentId = 0;
    }

    fillDropdown() {
        
        this._commonLookupService.getAllDepartmentForTableDropdown().subscribe((result) => {
            this.allDepartments = result;
        });
        this._commonLookupService.getAllCategoryForTableDropdown().subscribe((result) => {
            this.allCategorys = result;
        });
        this._commonLookupService.getAllSubCategoryForTableDropdown().subscribe((result) => {
            this.allSubCategorys = result;
        });
        this._commonLookupService.getAllBrandForTableDropdown().subscribe((result) => {
            this.allBrands = result;
        });
        this._commonLookupService.getAllVendorForTableDropdown().subscribe((result) => {
            this.allVendors = result;
        });
    }

    getProducts(event?: LazyLoadEvent) {
        if (this.primengTableHelper.shouldResetPaging(event)) {
            this.paginator.changePage(0);
            if (this.primengTableHelper.records && this.primengTableHelper.records.length > 0) {
                return;
            }
        }

        this.primengTableHelper.showLoadingIndicator();

        this._productsServiceProxy
            .getAll(
                this.barCode,
                this.productCode,
                this.productName,
                this.appSession.user.locationId,
                this.departmentId,
                this.categoryId,
                this.productType,
                this.brandId,
                this.vendorId,
                this.primengTableHelper.getSorting(this.dataTable),
                this.primengTableHelper.getSkipCount(this.paginator, event),
                this.primengTableHelper.getMaxResultCount(this.paginator, event),
            )
            .subscribe((result) => {
                this.primengTableHelper.totalRecordsCount = result.totalCount;
                this.primengTableHelper.records = result.items;
                this.primengTableHelper.hideLoadingIndicator();
            });
    }

    reloadPage(): void {
        this.paginator.changePage(this.paginator.getPage());
    }

    createProduct(): void {
        this._router.navigate(['/app/inventory/products/createOrEdit']);
    }

    deleteProduct(product: ProductDto): void {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                this._productsServiceProxy.delete(product.id).subscribe(() => {
                    this.reloadPage();
                    this.notify.success(this.l('SuccessfullyDeleted'));
                });
            }
        });
    }

    exportToExcel($event): void {
        //this._productsServiceProxy
        //    .getProductsToExcel(
        //        this.filterText,
        //        $event,
        //        this.unitNameFilter,
        //        undefined,
        //        this.departmentNameFilter,
        //        undefined,
        //        this.categoryNameFilter,
        //        undefined,
        //        this.subCategoryNameFilter,
        //        undefined,
        //        this.brandNameFilter,
        //        undefined,
        //        this.vendorNameFilter,
        //        undefined,
        //        this.taxNameFilter,
        //        undefined,
        //    )
        //    .subscribe((result) => {
        //        this._fileDownloadService.downloadTempFile(result);
        //    });
    }

    uploadExcel(data: { files: File }): void {
        const formData: FormData = new FormData();
        const file = data.files[0];
        formData.append('file', file, file.name);
        this._httpClient
            .post<any>(this.uploadUrl, formData)
            .pipe(finalize(() => this.excelFileUpload.clear()))
            .subscribe((response) => {
                if (response.success) {
                    this.notify.success(this.l('AllProductsSuccessfullyImportedFromExcel'));
                    this.importDialoug = false;
                    this.getProducts({});
                } else if (response.error != null) {
                    this.notify.error(this.l('ImportProductsUploadFailed'));
                }
            });
            
    }

    onUploadExcelError(): void {
        this.notify.error(this.l('ImportProductsUploadFailed'));
    }

    onUploadExcelSuccess(): void {
        debugger;
        this.getProducts({}); 
    }

    resetFilters(): void {
        this.barCode = '';
        this.productCode = '';
        this.productName = '';
        this.brandId = 0;
        this.vendorId = 0;
        this.categoryId = 0;
        this.vendorId = 0;
        this.departmentId = 0;
      
        this.getProducts();
    }

    showExcelColumnSelectionModal() {
        this._productsServiceProxy.getProductExcelColumnsToExcel().subscribe((result) => {
            this.excelColumnSelectionModal.show(result);
        });
    }
}
